import { Button } from '@/components/ui/button'
import { Separator } from '@/components/ui/separator'

import type { FC, ReactNode } from 'react'

export interface SidePanelFooterProps {
	/**
	 * Button label text
	 */
	buttonLabel: string
	/**
	 * Button icon
	 */
	icon?: ReactNode
	/**
	 * Button click handler
	 */
	handler?: () => void
	/**
	 * Whether the button is disabled
	 */
	disabled?: boolean
	/**
	 * The type of the button
	 */
	buttonType?: 'button' | 'submit' | 'reset'
}

export const SidePanelFooter: FC<SidePanelFooterProps> = ({
	buttonLabel,
	icon,
	handler,
	disabled,
	buttonType,
}) => {
	return (
		<div className="bg-background border-r">
			<Separator />
			<div className="p-3">
				<Button
					variant="default"
					onClick={handler}
					disabled={disabled}
					className="w-full"
					type={buttonType}
				>
					{icon && <span className="mr-2">{icon}</span>}
					{buttonLabel}
				</Button>
			</div>
		</div>
	)
}
